const hostname = window.location.hostname;

let apiBase: string | undefined = import.meta.env.VITE_API_BASE_URL;

if (!apiBase) {
  if (hostname.includes('staging')) {
    apiBase = import.meta.env.VITE_API_BASE_STAGING;
  } else if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    // Local dev should talk to the Flask backend directly to avoid proxy drift.
    apiBase = 'http://127.0.0.1:5000';
  }
}

export const API_BASE = apiBase || '';
